import { STATSIG_EXPERIMENTS, STATSIG_EXPERIMENTS_BUCKETS } from '@src/config/statsig-experiments.config'
import { useStatsigExperiment } from '@src/experiments/statsig-integration'

export default function useATCVsATBExperiment(): boolean {
  const { experimentBucket } = useStatsigExperiment(STATSIG_EXPERIMENTS.ATC_VS_ATB_COPY_WEB)
  return experimentBucket === STATSIG_EXPERIMENTS_BUCKETS.SHOW
}
